module.exports = __webpack_public_path__ + "img/thema-five-banner.141d7fdd.jpg";